/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { Surface } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Action from './Action';
import Info from './Info';
import Title from './Title';

const Styles = {
  root: css`
    padding: 20px;
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    gap: 16px;
  `,
};

function CTA({ children }: PropsWithChildren<{}>) {
  return (
    <Surface borderColor="GrayWarm4">
      <section css={Styles.root}>{children}</section>
    </Surface>
  );
}

CTA.Title = Title;
CTA.Action = Action;
CTA.Info = Info;

export default CTA;
